import styled from 'styled-components';

const TabStyle = styled.div`
	--tabPadTB: var(--sp3x);
	--tabPadLR: var(--sp6x);
	--tabBorderRadius: var(--sp7x);

	width: fit-content;
	overflow: hidden;
	z-index: 100;
	cursor: pointer;

	.tab-text {
		padding: var(--tabPadTB) var(--tabPadLR);
		/* background-color: transparent; */
		background-color: var(--lightGray1000);
		border-radius: var(--tabBorderRadius);
		border: 1px solid var(--green1000);
		transition: all var(--trTime) ease-out;
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			&:hover {
				.tab-text {
					background-color: var(--green1000);
					color: var(--white1000);
				}
			}
		}
	}

	&.active {
		pointer-events: none;
		cursor: default;

		.tab-text {
			background-color: var(--green1000);
			color: var(--white1000);
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--tabPadTB: var(--sp2x);
		--tabPadLR: var(--sp5x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--tabPadLR: var(--sp4x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--tabPadTB: var(--sp1-5x);
		--tabPadLR: var(--sp3x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default TabStyle;
